import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const customStringsAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.CustomStringsViewAccess],
}

export const customStringsCreateAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.CustomStringsModifyAccess],
}
